"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconsSector = exports.assignUUIDs = void 0;
const icon_1 = require("@app/component/ui/icon");
const text_1 = require("@app/component/ui/text");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
require("./icons-sector.scss");
const emptyIcon = () => ({});
const isAvailability = (t) => 'available' in t;
const isTimeOff = (t) => !isAvailability(t);
const assignUUIDs = (icons) => icons.map((ico) => ({ ...ico, id: (0, uuid_1.v4)() }));
exports.assignUUIDs = assignUUIDs;
const processWarnings = (calendarFilters, warnings) => {
    const warnFilter = calendarFilters.find((f) => f.hideWarnings);
    // process warnings based on calendar filters
    if ((0, util_1.isValue)(warnings) && warnFilter?.hideWarnings) {
        if (warnFilter.hideWarnings === 'all' || warnFilter.hideWarnings === true) {
            return undefined;
        }
        else if (Array.isArray(warnFilter.hideWarnings)) {
            return warnings.filter((w) => !warnFilter.hideWarnings.includes(w.name));
        }
    }
    return warnings;
};
const getShiftIcons = (shift, calendarFilters) => {
    const icons = [
        emptyIcon(),
        emptyIcon(),
        emptyIcon(),
    ];
    const warnings = processWarnings(calendarFilters, shift.warnings);
    // first column
    if ((0, util_1.isValue)(warnings) && warnings.length > 0) {
        icons[0] = { ico: 'warning' };
    }
    else if ((0, util_1.isValue)(shift.hasOffer)) {
        icons[0] = {
            ico: 'radio-unchecked',
            extra: {
                number: [
                    shift.hasOffer.announceAction?.result.replies?.filter((rep) => rep.reply === 'yes').length ?? 0,
                    [...new Set(shift.hasOffer.announceAction?.targetUsers)].length,
                ],
            },
        };
    }
    // second column
    if ((0, util_1.isValue)(shift.transfer)) {
        icons[1] = { ico: 'exchange' };
    }
    else if ((0, util_1.isValue)(shift.customAttributes) && shift.customAttributes.length > 0) {
        icons[1] = { ico: 'items' };
    }
    else if (shift.standBy) {
        const hasItems = (0, util_1.isValue)(shift.standByActivities) && shift.standByActivities.length > 0;
        icons[1] = { ico: hasItems ? 'phone-plus' : 'phone' };
    }
    // third column
    if ((0, util_1.isValue)(shift.transfer) && (0, util_1.isValue)(shift.requestPendingAction)) {
        icons[2] = { ico: 'question' };
    }
    else if ((0, util_1.isValue)(shift.overTime)) {
        icons[2] = { ico: 'standards' };
    }
    else if ((0, util_1.isValue)(shift.note) && shift.note.length > 0) {
        icons[2] = { ico: 'comment' };
    }
    else if ((0, util_1.isValue)(shift.agenda) && shift.agenda.length > 0) {
        icons[2] = { ico: 'checkboxes' };
    }
    return icons;
};
const getTimeOffOrAvailIcons = (timeOffOrAvail, calendarFilters) => {
    const icons = [
        emptyIcon(),
        emptyIcon(),
        emptyIcon(),
    ];
    const warnings = processWarnings(calendarFilters, timeOffOrAvail.warnings);
    // first column
    if ((0, util_1.isValue)(warnings) && warnings.length > 0) {
        icons[0] = { ico: 'warning' };
    }
    // second column
    if (isTimeOff(timeOffOrAvail) && (0, util_1.isValue)(timeOffOrAvail.requestPendingAction)) {
        icons[1] = { ico: 'question' };
    }
    // third column
    if (isTimeOff(timeOffOrAvail) &&
        (0, util_1.isValue)(timeOffOrAvail.attachments) &&
        timeOffOrAvail.attachments.length > 0) {
        icons[2] = { ico: 'attachment' };
    }
    else if ((0, util_1.isValue)(timeOffOrAvail.note) && timeOffOrAvail.note.length > 0) {
        icons[2] = { ico: 'comment' };
    }
    return icons;
};
const IconsSector = ({ shift, timeOffOrAvail, calendarFilters, }) => {
    const [icons, setIcons] = react_1.default.useState((0, exports.assignUUIDs)([{ ico: 'question' }, { ico: 'switch' }, { ico: 'assign' }]));
    react_1.default.useEffect(() => {
        if ((0, util_1.isDefined)(shift)) {
            setIcons((0, exports.assignUUIDs)(getShiftIcons(shift, calendarFilters)));
        }
        if ((0, util_1.isDefined)(timeOffOrAvail)) {
            setIcons((0, exports.assignUUIDs)(getTimeOffOrAvailIcons(timeOffOrAvail, calendarFilters)));
        }
    }, [shift, timeOffOrAvail, calendarFilters]);
    if (timeOffOrAvail?.id === '69c3dea7d4b3cb21449feae1') {
        console.log(timeOffOrAvail);
    }
    return (react_1.default.createElement("div", { className: 'ds-event-icons' },
        react_1.default.createElement("div", { className: 'ds-event-icon-grid' }, icons.map((data) => (react_1.default.createElement("div", { key: data.id, style: {
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
            } }, (0, util_1.isDefined)(data.ico) ? ((0, util_1.isDefined)(data.extra) ? (react_1.default.createElement(text_1.Text, { type: text_1.Text.TYPES.BODY_SMALL, color: text_1.Text.COLORS.INHERIT, text: `${data.extra.number[0]}/${data.extra.number[1]}`, weight: 'bold' })) : (react_1.default.createElement(icon_1.Icon, { ico: data.ico }))) : null))))));
};
exports.IconsSector = IconsSector;
